<template>
  <div class="menu-list-wrap">
    <keep-alive>
      <menu-detail v-if="checkShowDetail()"></menu-detail>
      <menu-item v-else></menu-item>
    </keep-alive>
    <quantity></quantity>
  </div>
</template>
<script>
import { mapGetters } from 'vuex';
import { defineAsyncComponent } from 'vue';
import MenuItem from '@/components/order/right/menu/MenuItem.vue';
import MenuDetail from '@/components/order/right/menu/MenuDetail.vue';
export default {
  name: 'menu-list',
  components: {
    Quantity: defineAsyncComponent(() => import('@/components/order/right/menu/Quantity.vue')),
    MenuItem,
    MenuDetail,
  },
  computed: {
    ...mapGetters('menuItem', ['isMenuDetail', 'getItemId']),
    ...mapGetters('list', ['isNoChoose']),
  },
  methods: {
    checkShowDetail() {
      if (this.getItemId) {
        if (this.isMenuDetail) return true;
        else return false;
      } else {
        if (this.isMenuDetail && !this.isNoChoose) return true;
        else return false;
      }
    },
  },
};
</script>
<style lang="scss" scoped>
.menu-list-wrap {
  width: 100%;
  height: 100%;
  display: grid;
  grid-template-rows: auto minmax(50px, 10%);
  text-align: center;
}
</style>
